export default __webpack_public_path__ + "static/media/sentempty.faf6efcf.svg";